import { ProgramCard } from '@components/buzzkuri/pages/top/OnlineProgramSection/Card'
import { LightHeading } from '@components/buzzkuri/shared/uiParts/heading/LightHeading'
import { Objective } from '@type/buzzkuri/home'

type Props = {
  objectives: Objective[]
}

export const FindFromTarget = ({ objectives }: Props): JSX.Element => {
  return (
    <div className="flex flex-col">
      <div>
        <LightHeading text="目的から探す" />
      </div>
      <div className="flex flex-row flex-wrap justify-between items-stretch mt-[5.6vw] lg:mt-[1.6vw] lg:w-[62.5vw] h-[139.2vw] lg:h-[44.2vw]">
        {objectives.map((program, i) => (
          <ProgramCard
            key={i}
            title={program.name}
            description=""
            href={`/programs/${program.name.replace('\n', '')}`}
            imgSize={{ w: 343, h: 185 }}
            cardRowNum={3}
            imagePath={program.imageFilePath}
            size="small"
            isAnimation={false}
          />
        ))}
      </div>
    </div>
  )
}
